module.exports = __webpack_public_path__ + "img/51_44.2eeb56c4.png";